export default{name:"tabbar",computed:{configurator:function configurator(){return this.$store.state.configurator},isVisible:function isVisible(){return this.$store.state.isTabbarVisible}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/partials/TabBar.vue
// module id = 277
// module chunks = 0